import {
  RewardListPageKey,
  VoucherCodeSetupPageKey,
  RewardSellingModalKey,
  StatusTextKey,
  RewardModalKey
} from '../../TModules';

export const translations = {
  [RewardListPageKey]: {
    Reward: 'Ricompensa',
    List: 'Lista',
    All: 'Tutti',
    Draft: 'Bozza',
    Pending: 'In sospeso',
    Scheduled: 'Programmato',
    Active: 'Attivo',
    Ended: 'Terminato',
    Inactive: 'Inattivo',
    TransactionIssued: 'Transazione emessa',
    Private: 'Privato',
    System: 'Sistema',
    SellingFast: 'Vendita rapida',
    SoldOut: 'Esaurito',
    Subtitle: 'Sottotitolo',
    Stackable: 'Impilabile',

    Name: 'Nome',
    Merchant: 'Commerciante',
    Status: 'Stato',
    Balance: 'Saldo',
    RedemptionBalance: 'Saldo di riscatto',
    RewardRedeemed: 'Riscattato',
    VoidedReward: 'Annullato',
    SellingFrom: 'Vendita da',
    SellingTo: 'Vendita fino a',
    Actions: 'Azioni',
    RequestType: 'Tipo di richiesta',
    Comments: 'Commenti',
    LastUpdated: 'Ultimo aggiornamento',

    CreateNew: 'Crea nuovo',
    Edit: 'Modifica',
    DownloadCodes: 'Scarica codici',
    DuplicateReward: 'Duplica ricompensa',
    Deactivate: 'Disattiva',
    Activate: 'Attiva',
    DownloadDepletedCodes: 'Scarica codici esauriti',
    UnassginedVouchers: 'Buoni non assegnati',
    ReplinishVouchers: 'Riempire i buoni',
    Deplete: 'Esaure',
    Replinish: 'Riempire',
    AppendBudget: 'Aggiungi budget',
    Approve: 'Approva',
    RequestDeletion: 'Richiedi eliminazione',
    PublishNew: 'Pubblica nuovo',
    Reactivate: 'Riattiva',
    NA: 'N.A',

    Type: 'Tipo',
    RewardName: 'Nome della ricompensa',
    Description: 'Descrizione',
    StepsToRedeem: 'Passaggi per riscattare',
    SellingPeriod: 'Periodo di vendita',
    ActiveAt: 'Attivo a',
    TermsAndConditions: 'Termini e condizioni',
    RiskDisclaimer: 'Avvertenza sui rischi',
    BrandName: 'Nome del marchio',
    Brands: 'Marchi',
    Tags: 'Tag',
    Categories: 'Categorie',
    Labels: 'Etichette',
    Catalogues: 'Cataloghi',
    UploadedPhotos: 'Foto caricate',
    UploadedPhoto: 'Foto caricata',
    UploadMultipleImages: 'Carica più immagini',
    UploadAFile: 'Carica un file',
    WhereCanThisbeRewardDisplayed: 'Dove può essere visualizzata questa ricompensa',
    RewardCost: 'Costo della ricompensa',
    SellingPrice: 'Prezzo di vendita',
    CustomFields: 'Campi personalizzati',

    AudienceInfo: 'Informazioni sul pubblico',
    AudienceAttributes: 'Attributi del pubblico',
    AudienceList: 'Elenco del pubblico',
    NoFiltersSelected: 'Nessun filtro selezionato',
    NoListSelected: 'Nessun elenco selezionato',

    RewardsMechanics: 'Meccaniche di ricompensa',
    CodeType: 'Tipo di codice',
    Code: 'Codice',
    VoucherCodeType: 'Tipo di codice voucher',
    RewardIssuanceLimit: 'Limite di emissione della ricompensa',
    TotalRedemptionLimit: 'Limite totale di riscatto',
    RedemptionLimitsPerPeriod: 'Limiti di riscatto per periodo',
    RewardIssuancePerPeriodLimit: 'Limite di emissione della ricompensa per periodo',
    UserLimits: 'Limiti utente',
    UserLimitsPerPeriod: 'Limiti utente per periodo',
    VoucherValidity: 'Validità del voucher',
    RedemptionType: 'Tipo di riscatto',
    GiftingOption: 'Opzione regalo',

    Public: 'Pubblico',
    MainBodyText: 'Testo principale',
    AddAccordion: 'Aggiungi fisarmonica',

    Next: 'Avanti',
    Cancel: 'Annulla',
    Browse: 'Sfoglia',
    Back: 'Indietro',
    SaveAsDraft: 'Salva come bozza',
    Launch: 'Lancia',
    Publish: 'Pubblica',
    Save: 'Salva',
    ImportReward: 'Importa ricompensa',
    PerIssuance: 'Per emissione',
    ConversionMetric: 'Metrica di conversione',
    CostPerIssued: 'Costo per emissione',
    BudgetAllocation: 'Assegnazione budget',
    Inventory: 'Inventario',
    ActivationDate: 'Data di attivazione',
    StartDate: 'Data di inizio',
    EndDate: 'Data di fine',
    OperatingDays: 'Giorni operativi',
    From: 'Da',
    DiscountStartDate: 'Data di inizio sconto',
    DiscountEndDate: 'Data di fine sconto',
    ID: 'ID',
    CashValue: 'Valore in contanti',

    PointsValue: 'Valore in punti',
    LoyaltyProgram: 'Programma fedeltà',
    Identifier: 'Identificatore',
    Action: 'Azione',
    ThisRewardsIsCurrentlyFREE: 'Questa ricompensa è attualmente GRATUITA',
    ReActivateSellingPrice: 'Riattiva un prezzo di vendita qui sotto o aggiungine uno nuovo',
    AddSellingPrice: 'Aggiungi prezzo di vendita',
    EditSellingPrice: 'Modifica prezzo di vendita',
    HowDoYouValueYourRewards: 'Come valuti le tue ricompense?',
    CostPrice: 'Prezzo di costo',
    SocialMedia: 'Social media',
    Title: 'Titolo',
    Image: 'Immagine',
    iOSAppLink: 'Link app iOS',
    AndroidAppLink: 'Link app Android',
    WebLink: 'Link web',
    AddCustomField: 'Aggiungi campo personalizzato',
    CustomField: 'Campo personalizzato',
    TypeInFieldName: 'Inserisci il nome del campo',
    TypeInFieldValue: 'Inserisci il valore del campo',
    SelectCodeType: 'Seleziona tipo di codice',
    TypeOfCode: 'Tipo di codice',
    GenericCode: 'Codice generico',
    QRCode: 'Codice QR',
    BarCode: 'Codice a barre',
    URL: 'URL',
    SelectFile: 'Seleziona file',
    ChooseFile: 'Scegli file',
    DownloadSample: 'Scarica esempio (Formato accettato: solo file .xlsx/.csv)',
    ErrorParsingTheFile: "Errore durante l'analisi del file",
    SelectStashReward: 'Seleziona Ricompensa Stash',
    RewardHasToBeLinkedToAStashReward: 'La Ricompensa Deve Essere Collegata A Una Ricompensa Stash',
    InventorySource: "Fonte dell'inventario",
    Limits: 'Limiti',
    IssueAMaximumOf: 'Emetti un massimo di',
    RewardsPer: 'Ricompense per',
    Second: 'Secondo',
    Minutes: 'Minuti',
    Hours: 'Ore',
    Days: 'Giorni',
    Weeks: 'Settimane',
    Months: 'Mesi',
    Month: 'Mese',
    Year: 'Anno',
    ALifetimeLimitMustBeSet: 'Deve essere impostato un limite a vita',
    TheMaximumLimitIs: 'La limite massimo è',
    TheLimitMustBeMoreThan: 'La limite deve essere superiore a',
    DisplayEvenWhenIssuanceLimitIsReached:
      'Visualizza anche quando il limite di emissione è raggiunto',
    RewardRedemptionLimit: 'Limite di riscatto della ricompensa',
    LimitRedemptionsTo: 'Limita i riscatti a',
    PleaseFillInTheLimitRedemptionToValue: 'Compila il valore del limite di riscatto',
    PleaseFillInTheRedemptionIntervalUnits: 'Compila le unità dell’intervallo di riscatto',

    UserLimit: 'Limite utente',
    UserLimitPerPeriod: 'Limite utente per periodo',
    DisplayEvenWhenLimitIsReached: 'Visualizza anche quando il limite è raggiunto',
    ValidityPeriod: 'Periodo di validità',
    AfterDateOfPurchaseDate: 'Dopo la data di acquisto',
    SelectType: 'Seleziona tipo',
    Period: 'PERIODO',
    IssuanceDate: 'DATA DI EMISSIONE',
    EndOfMonth: 'FINE DEL MESE',
    RedemptionOutcomes: 'Risultati di riscatto',
    AddOutcome: 'Aggiungi risultato',
    Online: 'ONLINE',
    Offline: 'OFFLINE',
    MerchantPIN: 'PIN DEL COMMERCIANTE',
    Pin: 'PIN',
    APIRedemption: 'RISCATTO API',
    SetCountdown: 'Imposta conto alla rovescia',
    SelectGiftingOption: 'Seleziona opzione regalo',
    ScheduleLaunch: 'Pianifica lancio',
    MapYourRewardTo: 'Mappa la tua ricompensa a',
    Include: 'Includi',
    SneakPeek: 'Anteprima',
    SelectLoyaltyProgram: 'Seleziona il tuo programma fedeltà',
    PickAudienceList: 'Seleziona elenco pubblico',
    UploadNewList: 'Carica nuovo elenco',
    AcceptedFormat: 'Formato accettato: solo file .xlsx/.csv',
    AudienceNotInList: "Pubblico non nell'elenco?",
    PleaseSelectAMerchant: 'Seleziona un commerciante',
    StartDateEndDateRequired: 'Data di inizio e data di fine richieste',
    EndDateCannotBeBeforeStartDate: 'La data di fine non può essere precedente alla data di inizio',
    RewardHasToBeLinkedToAnInventoryItem:
      'La ricompensa deve essere collegata a un elemento dell’inventario',
    BatchNeedsToBeSelected: 'Deve essere selezionato un lotto',
    NumberOfVouchersMustBeGreaterOrEqual1: 'Il numero di voucher deve essere ≥ 1',
    VoucherCodesCannotBeEmpty: 'I codici voucher non possono essere vuoti',
    Batches: 'Lotti',
    MerchantName: 'Nome del commerciante',
    UNASSIGNED_VOUCHER_CODES: 'CODICI VOUCHER NON ASSEGNATI',
    ACTIVE_INVENTORY_BALANCE: 'SALDO INVENTARIO ATTIVO',
    OutOf: 'su',
    IncludeFromBatch: 'Includi dal lotto',
    VoucherCodes: 'Codici voucher',
    IncludeAnotherBatch: 'Includi un altro lotto',
    PrefixForVoucherCode: 'Prefisso per il codice voucher',
    LengthOfCode: 'Lunghezza del codice',
    CodeFormat: 'Formato del codice',
    Total: 'Totale',
    PossibleTotalPermutations: 'Numero totale di permutazioni possibili',
    SelectOption: 'Seleziona opzione',
    RedemptionTypeEditError:
      'Spiacente, non puoi modificare il tipo di riscatto di una ricompensa attiva.',
    EnterCallToActionURL: 'Inserisci l’URL della call to action',
    APIEndpoint: 'Endpoint API',
    QueryParamsValue: 'Valore dei parametri della query',
    BodyParamsValue: 'Valore dei parametri del corpo',
    PleaseSelectRedemptionType: 'Seleziona il tipo di riscatto',
    PleaseSelectAnAPI: "Seleziona un'API",
    Key: 'Chiave',
    Value: 'Valore',
    Prefix: 'Prefisso',
    Postfix: 'Suffisso',
    isRequired: 'è richiesto',
    IDENTIFIER: 'IDENTIFICATORE',
    PROGRAM: 'PROGRAMMA',
    POINTS: 'PUNTI',
    PRICE: 'PREZZO',
    LISTING: 'ELENCO',
    Exclude: 'Escludi',
    SneakPreview: 'Anteprima',

    ValidityAtLeastOneHour: 'La validità deve essere di almeno 1 ora',
    ValidFor: 'Valido per',
    GraceTime: 'Tempo di grazia',
    GraceTimeCannotBeNegative: 'Il tempo di grazia non può essere negativo',
    Yes: 'Sì',
    No: 'No',

    RewardInfo: 'Informazioni sulla ricompensa',
    RewardMechanics: 'Meccaniche di ricompensa',

    AddComment: 'Aggiungi commento',
    ThisRewardIsPendingApproval:
      'Questa ricompensa è in attesa di approvazione. Tutti i commenti aggiunti verranno mostrati qui.',
    ViewAndAddComments: 'Visualizza e aggiungi commenti',
    EnterYourCommentHere: 'Inserisci il tuo commento qui',
    DeleteComment: 'Eliminare il commento?',
    CommentDeleted: 'Commento eliminato',
    ErrorDeletingComment: "Errore durante l'eliminazione del commento",
    CommentsAdded: 'commenti aggiunti',
    AreYouSureYouWantToDeleteThisComment: 'Sei sicuro di voler eliminare questo commento',
    PendingReward: 'Ricompensa in sospeso',
    RewardMustHaveAName: 'La ricompensa deve avere un nome',
    AllowedFileTypes: 'Consentito: .jpg, .png, .svg',
    EitherAniOSOrAndroidOrWebLinkIsRequired: 'È richiesto un link iOS, Android o Web',
    Delete: 'Elimina',
    InsertPhoto: 'Inserisci foto',
    SelectImageType: 'Seleziona immagini png, svg, jpeg o gif',
    Info: 'Info',
    Audience: 'Pubblico',
    SelectAudience: 'Seleziona pubblico',
    Review: 'Revisione',
    Mechanics: 'Meccaniche',
    RewardDetails: 'Dettagli della ricompensa',
    SelectDate: 'Seleziona data',
    SelectTime: 'Seleziona ora',

    PleaseSelectYourBrands: 'Seleziona i marchi',
    PleaseSelectYourTags: 'Seleziona i tag',
    PleaseSelectYourCategories: 'Seleziona le categorie',
    PleaseSelectYourLabels: 'Seleziona le etichette',
    PleaseSelectYourCatalogues: 'Seleziona i cataloghi',
    PleaseSelectAnOwner: 'Seleziona un proprietario',
    TypeInYourRewardNameHere: 'Inserisci il nome della ricompensa qui',
    TypeInYourSubtitleNameHere: 'Inserisci il sottotitolo qui',

    EnglishRewardNameRequired: 'Il nome della ricompensa in inglese è richiesto',
    RewardNameRequired: 'Il nome della ricompensa è richiesto',
    StartDateRequired: 'La data di inizio è richiesta',
    RewardOwnerRequired: 'Il proprietario della ricompensa è richiesto',
    UploadedImagesShouldBeSetAsSection: 'Le immagini caricate devono essere impostate come sezione',
    DiscountStartDateCannotBeBlank: 'La data di inizio dello sconto non può essere vuota',
    DiscountEndDateCannotBeBlank: 'La data di fine dello sconto non può essere vuota',
    DiscountEndDateCannotBeBeforeDiscountStartDate:
      'La data di fine dello sconto non può essere precedente alla data di inizio dello sconto',
    RewardPartnerRequired: 'Il partner della ricompensa è richiesto',
    ValidityPeriodMustExtendPastSellingPeriod:
      'Il periodo di validità deve estendersi oltre il periodo di vendita.',
    RewardLimitFieldShouldBePositive: 'Il campo Limite ricompensa deve essere positivo',
    RewardLimitPerPeriodFieldShouldBePositive:
      'Il campo Limite ricompensa per periodo deve essere positivo',
    RewardLimitPerPeriodUnitsRequired: 'Le unità limite ricompensa per periodo sono richieste',
    RewardLimitPerPeriodUnitsShouldBeMoreThanZero:
      'Le unità limite ricompensa per periodo devono essere maggiori di zero',
    RewardLimitPerPeriodFieldRequired: 'Il campo Limite ricompensa per periodo è richiesto',
    RewardLimitPerPeriodFieldShouldBeMoreThanZero:
      'Il campo Limite ricompensa per periodo deve essere maggiore di zero',
    UserLimitFieldShouldBePositive: 'Il campo Limite utente deve essere positivo',
    UserLimitPerPeriodFieldShouldBePositive:
      'Il campo Limite utente per periodo deve essere positivo',
    UserLimitPerPeriodUnitsRequired: 'Le unità limite utente per periodo sono richieste',
    UserLimitPerPeriodUnitsShouldBeMoreThanZero:
      'Le unità limite utente per periodo devono essere maggiori di zero',
    UserLimitPerPeriodFieldRequired: 'Il campo Limite utente per periodo è richiesto',
    RedemptionIntervalUnitsOrLimitRedemptionToValueShouldBeMoreThanZero:
      'Le unità intervallo riscatto o il limite riscatto al valore devono essere maggiori di zero',
    ActivationStartDate: 'Data di attivazione',
    SetActivationStartDate: 'Data di attivazione set',
    ApproveReward: 'Approva ricompensa',
    SubmitDeletionRequest: 'Invia richiesta di eliminazione',
    AreYouSureYouWantToApproveThisReward: 'Sei sicuro di voler approvare questa ricompensa',
    ThisActionCannotBeUndone: 'Questa azione non può essere annullata',
    ThisRewardIsPendingApprovalAreYouSureYouWantToDeleteIt:
      'Questa ricompensa è in attesa di approvazione. Sei sicuro di volerla eliminare',
    OnceTheDeletionIsApprovedThisRewardWillNotBeAvailableAndYouWillNeedToCreateItAgain:
      "Una volta approvata l'eliminazione, questa ricompensa non sarà più disponibile e dovrai crearla di nuovo.",
    SetAs: 'Imposta come',
    Day: 'Giorno',
    PERIOD: 'PERIODO',
    To: 'a',
    ISSUANCE_DATE: 'DATA DI EMISSIONE',
    END_OF_MONTH: 'FINE MESE',
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
    PIN: 'PIN',
    Every: 'Ogni',
    OpenTimeIsRequired: "L'orario di apertura è obbligatorio",
    CloseTimeIsRequired: "L'orario di chiusura è obbligatorio",
    CloseTimeCannotBeBeforeOrSameAsOpenTime:
      "L'orario di chiusura non può essere precedente o uguale a quello di apertura",

    RewardOutcomesTable: {
      OutcomeType: 'Tipo di risultato',
      Value: 'Valore',
      LoyaltyProgram: 'Programma fedeltà',
      Action: 'Azione',
      SetOutcomeValue: 'Imposta valore risultato',
      Delete: 'Elimina'
    }
  },
  [VoucherCodeSetupPageKey]: {
    NoCode: 'Nessun codice',
    Single: 'Singolo',
    SystemGenerated: 'Generato dal sistema',
    UserUpload: 'Caricamento utente',
    Inventory: 'Inventario',
    Stash: 'Scorta',
    VoucherCodeSetup: 'Configurazione codice voucher',
    SelectCodeType: 'Seleziona tipo di codice',
    None: 'Nessuno'
  },
  [RewardSellingModalKey]: {
    SelectLoyaltyProgram: 'Seleziona programma fedeltà',
    SelectTier: 'Seleziona livello',
    Cash: 'Contanti',
    PointsRegularPrice: 'Punti (prezzo regolare)',
    PointsDiscountPrice: 'Punti (prezzo scontato)',
    egHundred: 'ad es. 100',
    Optional: 'Opzionale',
    SelectGLAccount: 'Seleziona GL Account',
    GLAccountType: 'Tipo di conto GL',
    GLAccountName: 'Nome del conto GL ',
    EitherPriceOrPointsIsRequired: 'È necessario indicare soit le prix o i punti', // needs correction
    DiscountPriceCannotBeMoreThanRegularPrice:
      'Il prezzo sconto non può essere superiore al prezzo normale',
    DiscountPriceShouldBeAtLeast: 'Il prezzo sconto deve essere almeno 1',
    Issue: 'Problema',
    Value: 'Valore',
    Points: 'Punti'
  },
  [StatusTextKey]: {
    active: 'Attivo',
    inactive: 'Inattivo',
    draft: 'Bozza',
    processing: 'In elaborazione',
    pending: 'In attesa',
    approved: 'Approvato',
    scheduled: 'Programmato',
    redeemed: 'Riscattato',
    ended: 'Terminato',
    failed: 'Fallito',
    fail: 'Errore',
    expired: 'Scaduto',
    public: 'Pubblico',
    success: 'Successo',
    completed: 'Completato',
    timeout: 'Timeout',
    system: 'Sistema',
    CreatingReward: 'Creazione Ricompensa...',
    RewardSubmittedForApproval: 'Ricompensa Inviata Per Approvazione',
    FailedToCreateReward: 'Creazione Della Ricompensa Fallita!',
    RewardApproval: 'Approvazione Ricompensa...',
    ApprovalSuccess: 'Approvazione Riuscita...',
    FailedToApprove: 'Approvazione Fallita!',
    DeactivationRequestSubmittedForApproval:
      'Richiesta Di Disattivazione Inviata Per Approvazione!',
    DeactivationSuccess: 'Disattivazione Riuscita...',
    FailedToDeactivate: 'Disattivazione Fallita!',
    RewardDeactivation: 'Disattivazione Ricompensa...',
    RewardReactivation: 'Riattivazione Ricompensa...',
    ReactivationSuccess: 'Riattivazione Riuscita...',
    ReactivationRequestSubmittedForApproval: 'Richiesta Di Riattivazione Inviata Per Approvazione!',
    FailedToReactivate: 'Riattivazione Fallita!',
    Processing: 'Elaborazione...',
    FailedToUpdateReward: 'Aggiornamento Della Ricompensa Fallito!',
    ErrorLoadingRewards: 'Errore Nel Caricamento Delle Ricompense!',
    ErrorLoadingTags: 'Errore Nel Caricamento Dei Tag!',
    ErrorLoadingBrands: 'Errore Nel Caricamento Dei Marchi!',
    ErrorLoadingAudiences: 'Errore Nel Caricamento Della Lista Pubblico!',
    SubmittingData: 'Invio Dei Dati...',
    FileUploadSuccess: 'Caricamento File Riuscito',
    DuplicatingReward: 'Duplicazione Ricompensa...',
    FailedToDuplicate: 'Duplicazione Fallita!',
    FailedToLoadData: 'Caricamento Dati Fallito!',
    CouldNotRetrieveRewards: 'Impossibile Recuperare Le Ricompense!',
    ErrorObtainingPartnerDetails: 'Errore Nel Recupero Dei Dettagli Del Partner!',
    ErrorLoadingMerchants: 'Errore Nel Caricamento Dei Commercianti!',
    ErrorLoadingLoyaltyList: 'Errore Nel Caricamento Della Lista Fedeltà!'
  },

  [RewardModalKey]: {
    CurrentTotalRewardLimit: 'Limite Totale Attuale Della Ricompensa',
    ReplenishVoucherCodesAndLimits: 'Rifornisci Codici E Limiti Dei Voucher',
    DepleteVoucherCodesAndLimits: 'Riduci Codici E Limiti Dei Voucher',
    Replenish: 'Rifornisci',
    Deplete: 'Riduci',
    Depleting: 'Riduzione In Corso',
    Replenishing: 'Rifornimento In Corso',
    UploadNewVoucherCodes: 'Carica Nuovi Codici Voucher',
    ClickOrDragFileToUpload: 'Fai Clic O Trascina Un File In Quest’Area Per Caricarlo',
    DepleteMustBeGreaterThanZero: 'La Riduzione Deve Essere Maggiore Di Zero.',
    DepletingReplenished: 'Riduzione Rifornita',
    SuccessfullyReplenished: 'Rifornito Con Successo',
    ThereAreDuplicatedCodes: 'Ci Sono {{count}} Codici Duplicati.',
    DownloadDuplicatedCodes: 'Scarica I Codici Duplicati',
    RewardLimitStatus: '{{value}} di {{total}} limite di ricompensa',
    ThereAreDepletedCodes: 'Ci Sono {{depleted_count}} Codici Esauriti.',
    DownloadDepletedCodes: 'Scarica I Codici Esauriti',
    DownloadLogFile: 'Scarica Il File Di Log',
    YouHaveDuplicateVoucherCodes:
      'Hai {{duplicates_count}} Codici Voucher Duplicati. Controlla Il Tuo File E Caricalo Di Nuovo.'
  }
};
